var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashActiveHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Trash_Active_-_Hover",
    "data-name": "Trash | Active - Hover",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.543,
    height: 22.797,
    viewBox: "0 0 19.543 22.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M13.168,20A1.168,1.168,0,0,0,12,21.168V31.924a4.36,4.36,0,0,0,4.36,4.36h7.564a4.36,4.36,0,0,0,4.36-4.36V21.168A1.168,1.168,0,0,0,27.115,20Zm3.717,11.4a.814.814,0,1,1-1.628,0V24.071a.814.814,0,1,1,1.628,0Zm4.071,0a.814.814,0,1,1-1.628,0V24.071a.814.814,0,1,1,1.628,0Zm4.071,0a.814.814,0,1,1-1.628,0V24.071a.814.814,0,1,1,1.628,0Z",
    transform: "translate(-10.37 -13.487)",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    "data-name": "Caminho 435",
    d: "M27.538,7.607a1.274,1.274,0,0,0-1.3-1.164H21.408a.383.383,0,0,1-.383-.383V5.628A1.628,1.628,0,0,0,19.4,4H16.14a1.628,1.628,0,0,0-1.628,1.628V6.06a.383.383,0,0,1-.383.383H9.3A1.274,1.274,0,0,0,8,7.607,1.221,1.221,0,0,0,9.219,8.885h17.1a1.221,1.221,0,0,0,1.221-1.278ZM19.4,6.035a.407.407,0,0,1-.407.407H16.547a.407.407,0,0,1,0-.814h2.443A.407.407,0,0,1,19.4,6.035Z",
    transform: "translate(-7.997 -4)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashActiveHover);
export default __webpack_public_path__ + "static/media/Trash  Active - Hover.7cd41a23.svg";
export { ForwardRef as ReactComponent };